import src from "IMAGE";
export default { src, width: 1440, height: 418, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAQklEQVR42j3JTQqAIBQAYe9/rdpGRT9UIi0UEeW9K4zowsUHA2Pe7+DcZv57IcWAiKCqXWvj7IVdJ9Kzk71DShyzqXcDOoC24XDBAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 2 }
